import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { TransactionIndexResponse } from '@/repositories/generated';

const content: TransactionIndexResponse[] = [
  {
    completedAt: '2022-12-15T15:22:00+09:00',
    transactionId: '00128475948544384532',
    transactionDetailType: 'PREPAID_SETTLEMENT',
    amount: 1000,
    status: 'SUCCESS',
    walletUserId: 132,
    externalWalletUserId: 'abd1234',
    companyName: '株式会社 〇〇ホールディングス',
    shopName: '□□□ 渋谷店',
    walletServiceName: '△△△ウォレット',
    giftName: '〇〇市プレミアム付商品券【青券】（一般点のみで利用可能）',
    transactionBreakDown: {
      basicPointAmount: 0,
      bonusPointAmount: 0,
      bonusValueAmount: 0,
      bulkGrantName: 'スペシャルポイント',
      campaignName: 'スペシャルキャンペーン',
      creditCardAmount: 0,
      creditCardPaymentCategory: '10',
      directBankAmount: 0,
      fundsTransferAmount: 0,
      prepaidValueAmount: 1000,
    },
  },
  {
    completedAt: '2022-12-15T14:13:00+09:00',
    transactionId: '00145475944739209745',
    transactionDetailType: 'CREDIT_CARD_SETTLEMENT',
    amount: 1000,
    status: 'FAILURE',
    walletUserId: 132,
    externalWalletUserId: '5678kdjs',
    companyName: '株式会社 〇〇ホールディングス',
    shopName: '□□□ 渋谷店',
    walletServiceName: '△△△ウォレット',
    giftName: undefined,
    transactionBreakDown: {
      creditCardAmount: 1000,
      creditCardPaymentCategory: '21',
    },
  },
  {
    completedAt: '2022-12-15T12:09:00+09:00',
    transactionId: '00158833233344455532',
    transactionDetailType: 'COUNTER_CHARGE',
    amount: 3000,
    status: 'CANCELED',
    walletUserId: 211,
    externalWalletUserId: '23kdfs23',
    companyName: '株式会社 〇〇ホールディングス',
    shopName: '□□□ 渋谷店',
    walletServiceName: '△△△ウォレット',
    giftName: '〇〇市プレミアム付商品券【青券】（一般点のみで利用可能）',
    transactionBreakDown: {
      prepaidValueAmount: 3000,
    },
  },
  {
    completedAt: '2022-12-15T12:09:00+09:00',
    transactionId: '00158833233344455532',
    transactionDetailType: 'SETTLEMENT_CANCEL',
    amount: 3000,
    status: 'SUCCESS',
    walletUserId: 211,
    externalWalletUserId: '23kdfs23',
    companyName: '株式会社 〇〇ホールディングス',
    shopName: '□□□ 渋谷店',
    walletServiceName: '△△△ウォレット',
    giftName: '〇〇市プレミアム付商品券【青券】（一般点のみで利用可能）',
    transactionBreakDown: {
      basicPointAmount: undefined,
      bonusPointAmount: undefined,
      bonusValueAmount: undefined,
      bulkGrantName: 'スペシャルポイント',
      campaignName: 'スペシャルキャンペーン',
      creditCardAmount: 0,
      creditCardPaymentCategory: '10',
      directBankAmount: 500,
      fundsTransferAmount: undefined,
      prepaidValueAmount: undefined,
    },
  },
  {
    completedAt: '2022-12-15T12:09:00+09:00',
    transactionId: '00158833233344455532',
    transactionDetailType: 'CHARGE_CANCEL',
    amount: 3000,
    status: 'SUCCESS',
    walletUserId: 211,
    externalWalletUserId: '23kdfs23',
    companyName: '株式会社 〇〇ホールディングス',
    shopName: '□□□ 渋谷店',
    walletServiceName: '△△△ウォレット',
    giftName: '〇〇市プレミアム付商品券【青券】（一般点のみで利用可能）',
    transactionBreakDown: {
      bonusPointAmount: 500,
      campaignName: 'スペシャルキャンペーン',
    },
  },
  {
    completedAt: '2022-12-15T12:09:00+09:00',
    transactionId: '00158833233344455532',
    transactionDetailType: 'SETTLEMENT_CANCEL',
    amount: 3000,
    status: 'SUCCESS',
    walletUserId: 211,
    externalWalletUserId: '23kdfs23',
    companyName: '株式会社 〇〇ホールディングス',
    shopName: '□□□ 渋谷店',
    walletServiceName: '△△△ウォレット',
    giftName: '〇〇市プレミアム付商品券【青券】（一般点のみで利用可能）',
    transactionBreakDown: {
      creditCardAmount: 25000,
      creditCardPaymentCategory: '80',
    },
  },
  {
    completedAt: '2022-12-15T15:22:00+09:00',
    transactionId: '00128475948544384532',
    transactionDetailType: 'PREPAID_SETTLEMENT',
    amount: 1000,
    status: 'SUCCESS',
    walletUserId: 132,
    externalWalletUserId: 'abd1234',
    companyName: '株式会社 〇〇ホールディングス',
    shopName: '□□□ 渋谷店',
    walletServiceName: '△△△ウォレット',
    giftName: '〇〇市プレミアム付商品券【青券】（一般点のみで利用可能）',
    transactionBreakDown: {
      basicPointAmount: 40,
      bonusPointAmount: 200,
      bulkGrantName: 'スペシャルポイント',
      directBankAmount: 30000,
      fundsTransferAmount: 4000,
    },
  },
];

const loopContent = new Array<string>(50)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const transaction = http.get(
  createMockEndpoint('/transaction'),
  async ({ request }) => {
    const url = new URL(request.url);
    await delay(500);
    const detailTypesExists = url.searchParams.get('transactionDetailTypes') ?? '';
    const statusExists = url.searchParams.get('status') ?? '';
    const shopExists = url.searchParams.get('shopNames') ?? '';
    const externalShopExists = url.searchParams.get('externalShopId') ?? '';
    const acquirerExists = url.searchParams.get('acquirerNames') ?? '';
    const companyExists = url.searchParams.get('companyNames') ?? '';

    if (detailTypesExists || statusExists || shopExists || externalShopExists || acquirerExists || companyExists) {
      return HttpResponse.json({
        content: loopContent.slice(3, 25),
        pageable: {
          sort: {
            empty: true,
            sorted: false,
            unsorted: true,
          },
          offset: 0,
          pageNumber: 0,
          pageSize: 20,
          paged: true,
          unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 20,
        size: 20,
        number: 0,
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        first: true,
        numberOfElements: 20,
        empty: false,
      }, { status: 200 });
    }
    // クエリパラメータなし
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);
